import React, { useState, useEffect, useRef, forwardRef } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Input, Tooltip, message, Upload, Progress, Image } from 'antd'

import styles from './index.module.css'
import { actionCreators } from '../../store'
import sendImg from '../../../../statics/send.png'
import loadingImg from '../../../../statics/loading.png'
import sendActiveImg from '../../../../statics/send_active.png'
import thingkingLoadingImg from '../../../../statics/thinking_loading.png'
import reasoningImg from '../../../../statics/reasoning.png'
import reasoningActiveImg from '../../../../statics/reasoning_active.png'
import materialImg from '../../../../statics/material_mode.png'
import materialActiveImg from '../../../../statics/material_mode_active.png'
import materialUploadImg from '../../../../statics/material_mode_upload.png'
import materialUploadActiveImg from '../../../../statics/material_mode_upload_active.png'
import materialUploadCloseImg from '../../../../statics/material_mode_upload_close.png'
import onlineImg from '../../../../statics/online_search.png'
import onlineActiveImg from '../../../../statics/online_search_active.png'


const UploadIcon = (props) => {
    const dispatch = useDispatch()
    let is_reasoning = useSelector(state => state.get('home').get('is_reasoning'))
    let is_material_mode = useSelector(state => state.get('home').get('is_material_mode'))
    let material_mode_uploading = useSelector(state => state.get('home').get('material_mode_uploading'))
    let material_mode_progress = useSelector(state => state.get('home').get('material_mode_progress'))
    let material_mode_preview_image = useSelector(state => state.get('home').get('material_mode_preview_image'))

    const handleUpload = (info) => {
        const { file } = info;

        if (file.status === 'uploading') {
            dispatch(actionCreators.materialModeUploading(true))
        }

        if (file.status === 'done') {
            dispatch(actionCreators.materialModeUploading(false))
            dispatch(actionCreators.materialModeProgress(100))      // 上传完成后将进度设置为 100%
            // message.success(`${file.name} 上传成功`);
        } else if (file.status === 'error') {
            dispatch(actionCreators.materialModeUploading(false))
            dispatch(actionCreators.materialModeProgress(0))
            dispatch(actionCreators.materialModePreviewImage(null))
            dispatch(actionCreators.materialModePreviewImageData({}))
            // message.error(`${file.name} 上传失败`);
        }
    }

    const customRequest = ({ file, onProgress, onSuccess, onError }) => {
        console.log("customRequest ===================");
        const interval = setInterval(() => {
            // props.setProgress((prev) => {
            //     const newProgress = prev + 10;
            //     if (newProgress >= 90) {
            //         clearInterval(interval); // 接近完成时停止模拟进度
            //     }
            //     onProgress({ percent: newProgress }, file);
            //     return newProgress;
            // });
            const newProgress = material_mode_progress + 10;
            console.log("home setInterval newProgress = ", newProgress);
            if (newProgress >= 90) {
                clearInterval(interval); // 接近完成时停止模拟进度
            }
            onProgress({ percent: newProgress }, file);
            dispatch(actionCreators.materialModeProgress(newProgress))
        }, 500);

        // 假设这是你添加的图片的 API
        const formData = new FormData();
        formData.append('image', file);

        dispatch(actionCreators.imageSearchUploadImage(formData, interval))
        .then((data) => {
            // dispatch(actionCreators.materialModePreviewImageData(data.data))
            onSuccess(null, file); // 上传成功
        })
        .catch((error) => {
            onError(error, file); // 上传失败
        })
        .finally(() => {
            // clearInterval(interval);
        })
    }

    const handlePreview = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            dispatch(actionCreators.materialModePreviewImage(e.target.result))
        };
        reader.readAsDataURL(file);
    }

    return (
        is_material_mode && !material_mode_preview_image ? (
            <Upload
                customRequest={customRequest}
                onChange={handleUpload}
                showUploadList={false}
                beforeUpload={(file) => {
                    handlePreview(file);
                    return true;
                }}
                maxCount={1} // 限制上传数量为 1
                accept={"image/*"}
            >
                <Tooltip placement="top" title={"上传图片"}>
                    <div className={styles.material_upload_active_box}>
                        <img src={materialUploadActiveImg} className={styles.reasoning_img} alt="icon" />
                    </div>
                </Tooltip>
            </Upload>
        ) : (
            <Tooltip placement="top" title={material_mode_preview_image ? "请先清除当前图片" : (is_reasoning ? "高级推理不支持上传图片" : "如需上传图片，请选择材料模式")}>
                <div className={styles.material_upload_box}>
                    <img src={materialUploadImg} className={styles.reasoning_img} alt="icon" />
                </div>
            </Tooltip>
        )
    )
}

const MessageInput = forwardRef((props, ref) => {
    const { handleOnBlur, handleOnFocus, ...rest } = props
    const dispatch = useDispatch()
    const textAreaRef = ref
    let prompt = useSelector(state => state.get('home').get('prompt'))
    let is_thinking = useSelector(state => state.get('home').get('is_thinking'))
    let is_mobile = useSelector(state => state.get('home').get('is_mobile'))
    let is_online_search = useSelector(state => state.get('home').get('is_online_search'))
    let is_reasoning = useSelector(state => state.get('home').get('is_reasoning'))
    let is_material_mode = useSelector(state => state.get('home').get('is_material_mode'))
    let material_mode_uploading = useSelector(state => state.get('home').get('material_mode_uploading'))
    let material_mode_progress = useSelector(state => state.get('home').get('material_mode_progress'))
    let material_mode_preview_image = useSelector(state => state.get('home').get('material_mode_preview_image'))
    let material_mode_preview_image_data = useSelector(state => state.get('home').get('material_mode_preview_image_data')).toJS()
    // const [uploading, setUploading] = useState(false);
    // const [progress, setProgress] = useState(0);
    // const [previewImage, setPreviewImage] = useState(null);
    // const [previewImageData, setPreviewImageData] = useState(null);

    useEffect(() => {
        if (!is_thinking && !is_mobile) {
            textAreaRef.current && textAreaRef.current.focus()
        }
    }, [is_thinking])

    const handleStopResponding = () => {
        dispatch(actionCreators.stopFetchResponding())
        dispatch(actionCreators.isStopFetchResponding(true))
        setTimeout(() => {
            console.log("test");
            dispatch(actionCreators.isStopFetchResponding(false))
        }, 2000); // 持续时间要比Message组件内部的定时器长一点确保它在动画完成后再消失
    }

    const pressEnter = (e) => {
        if (e.key === 'Enter' && e.keyCode === 13 && e.shiftKey) {
            // === 无操作 ===
        } else if (e.key === 'Enter' && e.keyCode === 13) {
            onSubmit()
            e.preventDefault() //禁止回车的默认换行
        }
    }

    const onChange = (e) => {
        let value = e.target.value
        dispatch(actionCreators.setPromptAction(value))
    }

    const onSubmit = () => {
        if (is_thinking) {
            return
        }

        if (JSON.stringify(material_mode_preview_image_data) !== '{}') {
            // 材料模式
            let image_data = JSON.parse(JSON.stringify(material_mode_preview_image_data))
            dispatch(actionCreators.sendAskAction(prompt, image_data))
            clearPreviewInfo()
        } else {
            if (prompt.trim() === '') {
                return
            }
            dispatch(actionCreators.sendAskAction(prompt))
        }
    }

    const onBlur = () => {
        handleOnBlur()
    }

    const onFocus = () => {
        handleOnFocus()
    }

    const handleOnlineSearch = () => {
        dispatch(actionCreators.setIsOnlineSearch(!is_online_search))
    }

    const handleIsReasoning = () => {
        if (!material_mode_uploading) {
            let status = !is_reasoning
            if (status) {
                dispatch(actionCreators.setIsMaterialMode(false))
                clearPreviewInfo()
            }
            dispatch(actionCreators.setIsReasoning(status))
        }
    }

    const handleMaterialMode = () => {
        if (!material_mode_uploading) {
            let status = !is_material_mode
            if (status) {
                dispatch(actionCreators.setIsReasoning(false))
            } else {
                clearPreviewInfo()
            }
            dispatch(actionCreators.setIsMaterialMode(status))
        }
    }

    const handleCancelPreviewImage = () => {
        if (!material_mode_uploading) {
            clearPreviewInfo()
        }
    }

    const clearPreviewInfo = () => {
        dispatch(actionCreators.materialModeUploading(false))
        dispatch(actionCreators.materialModeProgress(0))
        dispatch(actionCreators.materialModePreviewImage(null))
        dispatch(actionCreators.materialModePreviewImageData({}))
    }

    return (
        <div className={`${styles.textarea_box} ${material_mode_preview_image ? styles.textarea_image : null} ${is_mobile ? styles.mobile_textarea_box : ''}`}>
            <Input.TextArea
                value={prompt}
                size="large"
                placeholder={is_thinking ? "正在思考中..." : "发送你的问题给灵石AI..."}
                autoSize={{
                    maxRows: 10
                }}
                onPressEnter={pressEnter}
                onChange={onChange}
                ref={textAreaRef}
                className={styles.custom_textarea}
                onBlur={onBlur}
                onFocus={onFocus}
            />

            {
                is_thinking ? (
                    <div
                        className={styles.thinking_loading_box}
                        onClick={handleStopResponding}
                    >
                        <img
                            src={thingkingLoadingImg}
                            className={styles.circle_img}
                        />
                        <div className={styles.square_img}></div>
                    </div>
                ) : (
                    (prompt.trim() !== '' && !is_thinking) || (material_mode_preview_image) ? (
                        <img
                            src={sendActiveImg}
                            className={styles.send_butn_img}
                            onClick={onSubmit}
                            alt="发送"
                        />
                    ) : (
                        <img
                            src={sendImg}
                            className={styles.send_butn_img}
                        />
                    )
                )
            }

            <div className={styles.reasoning_box}>
                <div
                    className={`${styles.reasoning} ${is_reasoning ? styles.reasoning_active : null}`}
                    onClick={handleIsReasoning}
                >
                    {
                        is_reasoning ? (
                            <img src={reasoningActiveImg} className={styles.reasoning_img} alt="icon" />
                        ) : (
                            <img src={reasoningImg} className={styles.reasoning_img} alt="icon" />
                        )
                    }

                    <span className={styles.reasoning_text}>高级推理</span>
                </div>

                <div
                    className={`${styles.reasoning} ${is_material_mode ? styles.reasoning_active : null}`}
                    onClick={handleMaterialMode}
                >
                    {
                        is_material_mode ? (
                            <img src={materialActiveImg} className={styles.reasoning_img} alt="icon" />
                        ) : (
                            <img src={materialImg} className={styles.reasoning_img} alt="icon" />
                        )
                    }

                    <span className={styles.reasoning_text}>材料模式</span>
                </div>

                <div
                    className={`${styles.reasoning} ${is_online_search ? styles.reasoning_active : null}`}
                    onClick={handleOnlineSearch}
                >
                    {
                        is_online_search ? (
                            <img src={onlineActiveImg} className={styles.reasoning_img} alt="icon" />
                        ) : (
                            <img src={onlineImg} className={styles.reasoning_img} alt="icon" />
                        )
                    }

                    <span className={styles.reasoning_text}>联网搜索</span>
                </div>
            </div>

            {
                material_mode_preview_image ? (
                    <div className={styles.preview_image_container}>
                        <div className={styles.preview_image_box}>
                            <div
                                style={{
                                    width: 56,
                                    height: 56,
                                    backgroundImage: `url(${material_mode_preview_image})`,
                                    backgroundPosition: `50% center`,
                                    backgroundSize: 'cover',
                                    borderRadius: 12,
                                }}
                            ></div>
                            {/* <img
                                src={material_mode_preview_image}
                                alt="预览图"
                                style={{ maxWidth: '130px', maxHeight: '64px', borderRadius: 8 }}
                            /> */}
                            <div
                                className={styles.preview_close}
                                onClick={handleCancelPreviewImage}
                            >
                                <img
                                    src={materialUploadCloseImg}
                                    alt="close"
                                    className={styles.preview_close_img}
                                />
                            </div>
                        </div>

                        {/* <Image
                            src={material_mode_preview_image}
                            alt="预览图"
                            style={{ maxWidth: '130px', maxHeight: '64px', borderRadius: 8 }}
                        /> */}

                        {/* {material_mode_uploading && (
                            <div
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '56px',
                                    height: '56px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                    borderRadius: 8,
                                }}
                            >
                                <Progress
                                    type="circle"
                                    percent={material_mode_progress}
                                    size={50}
                                />
                            </div>
                        )} */}
                    </div>
                ) : null
            }

            {
                material_mode_preview_image && material_mode_uploading ? (
                    <div className={styles.material_mode_uploading_box}>
                        <div className={styles.material_mode_uploading_dashed}>
                            <div className={styles.uploading_preview_image_box}>
                                <img src={material_mode_preview_image} className={styles.uploading_preview_image} />

                                <div
                                    className={styles.preview_close}
                                    onClick={handleCancelPreviewImage}
                                >
                                    <img
                                        src={materialUploadCloseImg}
                                        alt="close"
                                        className={styles.preview_close_img}
                                    />
                                </div>
                            </div>

                            <div className={styles.material_mode_uploading_progress}>
                                <Progress
                                    type="line"
                                    percent={material_mode_progress}
                                    size="small"
                                />
                            </div>
                        </div>
                    </div>
                ) : null
            }

            <UploadIcon
                // uploading={uploading}
                // setUploading={setUploading}
                // progress={progress}
                // setProgress={setProgress}
                // previewImage={previewImage}
                // setPreviewImage={setPreviewImage}
                // setPreviewImageData={setPreviewImageData}
            />
        </div>
    )
})

export default MessageInput